import { createAction, handleActions } from 'redux-actions';
import createRequestSaga, {
  createRequestActionTypes,
} from '../../lib/createRequestSaga';
import { takeLatest } from 'redux-saga/effects';

import * as taxbillApi from '../../lib/api/taxbill';
import { firstDayofYear, lastDayofYear } from '../../utils/calcDatetime';

const [
  LIST_COLLECTS_BUYS,
  LIST_COLLECTS_BUYS_SUCCESS,
  LIST_COLLECTS_BUYS_FAILURE,
] = createRequestActionTypes('taxbill/LIST_COLLECTS_BUYS');

export const listCollectsBuys = createAction(
  LIST_COLLECTS_BUYS,
  (searchData) => searchData,
);
const listCollectsBuysSaga = createRequestSaga(
  LIST_COLLECTS_BUYS,
  taxbillApi.getTaxbills,
);

const SET_COLLECT_BUY_FILTERS = 'taxbill/SET_COLLECT_BUY_FILTERS';
export const setCollectsBuysFilters = createAction(
  SET_COLLECT_BUY_FILTERS,
  (filters) => filters,
);

const RESET_COLLECT_BUY_FILTERS = 'taxbill/RESET_COLLECT_BUY_FILTERS';
export const resetCollectsBuysFilters = createAction(RESET_COLLECT_BUY_FILTERS);

const UNLOAD_COLLECT_BUY = 'taxbill/UNLOAD_COLLECT_BUY';
export const unloadCollectsBuys = createAction(UNLOAD_COLLECT_BUY);

export function* collectsBuysSaga() {
  yield takeLatest(LIST_COLLECTS_BUYS, listCollectsBuysSaga);
}

const initialState = {
  collects_buys: null,
  totalPrice: null,
  defaultFilters: {
    searchInvTyp: '매출', //매입,매출
    searchTyp: '', //월간조회(현재 사용안함)
    searchYn: 'Y', //완료,미완료
    procCompYn: 'Y',
    searchKeyword: 'cstNm',
    searchWords: '',
    searchStrtDt: firstDayofYear,
    searchEndDt: lastDayofYear,
    // 홈 위젯(지급 예정) 딥링크 필터(메인화면 재검토, 2026-10-23) - 비어 있으면 서버 기존 동작.
    searchDateField: '',
  },
  error: null,
};

const collectsBuys = handleActions(
  {
    [LIST_COLLECTS_BUYS_SUCCESS]: (state, { payload: data }) => ({
      ...state,
      totalPrice: data?.totalPrice,
      collects_buys: data.list.map((inv) => ({
        id: inv.invUuid,
        invUuid: inv.invUuid,
        prjUuid: inv.prjUuid,
        roUuid: inv.roUuid,
        billUuid: inv.billUuid,
        invTyp: inv.invTyp,
        invTxt: inv.invTxt,
        cstNm: inv.cstNm,
        partnerNm: inv.partnerNm,
        invNo: inv.invNo,
        invYn: inv.invYn,
        invAmt: Number(inv.invAmt),
        salesUsrUuid: inv?.salesUsrUuid,
        salesUsrNm: inv?.salesUsrNm,
        reqPlanDt: inv.reqPlanDt,
        reqPlanYn: inv.reqPlanYn,
        reqPlanUsr: inv.reqPlanUsr,
        reqPlanUsrNm: inv.reqPlanUsrNm,
        reqPlanTxt: inv.reqPlanTxt,
        reqCompDt: inv.reqCompDt,
        reqCompYn: inv.reqCompYn,
        reqCompUsr: inv.reqCompUsr,
        reqCompUsrNm: inv.reqCompUsrNm,
        reqCompTxt: inv.reqCompTxt,
        procPlanDt: inv.procPlanDt,
        procPlanYn: inv.procPlanYn,
        procPlanUsrNm: inv.procPlanUsrNm,
        procCompDt: inv.procCompDt,
        procCompYn: inv.procCompYn,
        procTyp: inv.procTyp,
        rsltCompDt: inv.rsltCompDt,
        rsltCompYn: inv.rsltCompYn,
        osTran: inv.osTran,
        crtUsr: inv.crtUsr,
        crtNm: inv.crtNm,
        crtGradeNm: inv.crtGradeNm,
        crtDptNm: inv.crtDptNm,
        crtDt: inv.crtDt,
        cngUsr: inv.cngUsr,
        cngNm: inv.cngNm,
        cngDt: inv.cngDt,
      })),
      error: null,
    }),
    [LIST_COLLECTS_BUYS_FAILURE]: (state, { payload: error }) => ({
      ...state,
      error: error,
    }),
    [UNLOAD_COLLECT_BUY]: () => initialState,
    [RESET_COLLECT_BUY_FILTERS]: (state) => ({
      ...state,
      defaultFilters: initialState.defaultFilters,
    }),
    [SET_COLLECT_BUY_FILTERS]: (state, { payload: filters }) => ({
      ...state,
      defaultFilters: filters,
    }),
  },
  initialState,
);

export default collectsBuys;
